/* eslint-disable no-console */

/* eslint-disable func-names */
// Firebase Cloud Messaging Configuration File.
// Read more at https://firebase.google.com/docs/cloud-messaging/js/client && https://firebase.google.com/docs/cloud-messaging/js/receive
import {initializeApp} from "firebase/app";
import {getMessaging, getToken, onMessage} from "firebase/messaging";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Convert environment variables to URL `search` parameters
const firebaseConfigUrlSearchParams = new URLSearchParams(firebaseConfig).toString();

// Service worker URL w/config variables
const swUrl = `${process.env.PUBLIC_URL}/firebase-messaging-sw.js?${firebaseConfigUrlSearchParams}`;

// navigator.serviceWorker
//   .register(swUrl)
//   .then(function (registration) {
//     console.log("Registration successful, scope is:", registration.scope);
//   })
//   .catch(function (err) {
//     console.error("Service worker registration failed, error:", err);
//   });

export const VAPID_KEY = process.env.REACT_APP_VAPID_KEY;

initializeApp(firebaseConfig);

const messaging = getMessaging();

export const requestForToken = () => {
  return getToken(messaging, {vapidKey: VAPID_KEY})
    .then((currentToken) => {
      if (currentToken) {
        return currentToken;
        // eslint-disable-next-line no-else-return
      } else {
        console.error(
          "FCM ERROR: No registration token available. Request permission to generate one."
        );
        return null;
      }
    })
    .catch((err) => {
      console.error("FCM ERROR: An error occurred while retrieving token.", err);
      return null;
    });
};

// Handle incoming messages. Called when:
// - a message is received while the app has focus
// - the user clicks on an app notification created by a service worker `messaging.onBackgroundMessage` handler.
export const onMessageListener = () => {
  return new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
}
  
